import { ALL_FILTER_VALUE } from "../shared/constants";

/**
 * Most product rows one WEB_IT file can carry. Mirrors WEB_IT_MAX_DETAIL_ROWS in the
 * backend's sales-report module, which refuses to build a file with more rows.
 */
export const WEB_IT_MAX_DETAIL_ROWS = 70;

/** Name of the product flag that lists a product in the WEB_IT export file. */
export const WEB_IT_EXPORT_LABEL = "ออกใน WEB_IT";

/** The flag's two values as a product screen reads them. */
export const EXPORTED_LABEL = "ออก";
export const NOT_EXPORTED_LABEL = "ไม่ออก";

const EXPORTED_FILTER_VALUE = "exported";
const NOT_EXPORTED_FILTER_VALUE = "not_exported";

export const WEB_IT_EXPORT_FILTER_OPTIONS: { value: string; label: string }[] =
  [
    { value: ALL_FILTER_VALUE, label: "ทั้งหมด" },
    { value: EXPORTED_FILTER_VALUE, label: EXPORTED_LABEL },
    { value: NOT_EXPORTED_FILTER_VALUE, label: NOT_EXPORTED_LABEL },
  ];

const ALLOW_EXPORT_BY_FILTER_VALUE: Partial<Record<string, boolean>> = {
  [EXPORTED_FILTER_VALUE]: true,
  [NOT_EXPORTED_FILTER_VALUE]: false,
};

/** The `allow_export` list filter a select value stands for; undefined for "all". */
export const toAllowExportParam = (value: string): boolean | undefined =>
  ALLOW_EXPORT_BY_FILTER_VALUE[value];
